export enum ParentComponent {
  COMPLETE_THE_LOOK_GRID = 'CompleteTheLook',
  CONFIRMATION_ORDER = 'ConfirmationOrder',
  OUTFIT_INSPIRATION_APP = 'OutfitInspirationApp'
}
